/* istanbul ignore file */
import { BigFormRow } from 'framework/ui/layout';
import { NoteAttachmentUploaderInput } from 'domain/shared/artifact/input';
import { TimelineNoteWysiwygInput } from 'domain/shared/core/input';

const NoteForm = () => (
  <>
    <BigFormRow>
      <TimelineNoteWysiwygInput artifactsSource="attachmentsIds" source="noteText" label="Note text" />
    </BigFormRow>
    <BigFormRow>
      <NoteAttachmentUploaderInput label="Attachments" source="attachmentsIds" />
    </BigFormRow>
  </>
);

export default NoteForm;
